import {
	AgreedToTermsActionTypes,
	RESET_AGREED_TO_TERMS,
	SET_AGREED_TO_TERMS,
} from '../actions/agreedToTermsActionTypes';

const agreedToTerms = (state = false, action: AgreedToTermsActionTypes): boolean => {
	switch (action.type) {
		case SET_AGREED_TO_TERMS:
			return action.payload;
		case RESET_AGREED_TO_TERMS:
			return false;
		default:
			return state;
	}
};

export default agreedToTerms;
